var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('LoadingSpinner'):_c('div',{staticClass:"page-content column-padding-30",attrs:{"id":"page"}},[(_vm.page)?_c('page',{attrs:{"page":_vm.page,"global-state":_vm.globalState}}):_vm._e(),(!_vm.page)?_c('error',{attrs:{"error":_vm.error}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }